// removed by extract-text-webpack-plugin
module.exports = {"header":"header__3QGkI","desktop-nav":"desktop-nav__13NvL","active":"active__3gItZ","border":"border__1xcxT","burgerButton":"burgerButton__XbRfJ","mobile-menu":"mobile-menu__3uxgY","mobile-nav":"mobile-nav__B2D-M","mobile-menu-open":"mobile-menu-open__2taqt"};


//////////////////
// WEBPACK FOOTER
// ./components/header/style.css
// module id = u3et
// module chunks = 14